
import {Component, Prop, Watch} from 'nuxt-property-decorator';
import BaseInputComponent from '~/components/Form/BaseInputComponent';


@Component
export default class FormInputText extends BaseInputComponent {
  @Prop({
    type: Number,
    default: 3,
  })
  rows!: number | undefined

  @Prop({
    type: String,
    default: null,
  })
  value!: string

  @Prop({
    type: String,
    default: null,
  })
  innerClass!: string

  innerValue: string = ''

  @Watch('value')
  watchValue(v: string): void {
    this.innerValue = v;
  }

  @Watch('innerValue')
  watchInnerValue(v: string): void {
    this.$emit('input', v);
  }

  mounted() {
    this.innerValue = this.value;
  }
}
